import { render, staticRenderFns } from "./printRotationAlert.vue?vue&type=template&id=2e2fec36&"
import script from "./printRotationAlert.vue?vue&type=script&lang=ts&"
export * from "./printRotationAlert.vue?vue&type=script&lang=ts&"
import style0 from "./printRotationAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports